import { Clock, DollarSign, Shield, Users, Car, CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const benefits = [
  {
    icon: Clock,
    title: 'Save Time & Hassle',
    description: 'No more waiting rooms or dropping your car off. Our Mobile Car Servicing Gold Coast comes to your home or office at a time that suits you.',
    audience: 'Perfect for busy professionals and families'
  },
  {
    icon: DollarSign,
    title: 'Transparent Pricing',
    description: 'Get clear, upfront pricing with no hidden fees. Our Mobile Car Servicing Gold Coast ensures complete transparency from the start.',
    audience: 'Ideal for budget-conscious customers'
  },
  {
    icon: Car,
    title: 'Fleet Services Available',
    description: 'Multiple vehicles? Our Mobile Car Servicing Gold Coast offers convenient fleet maintenance for small businesses and multi-car families.',
    audience: 'Great for small businesses & large families'
  },
  {
    icon: Shield,
    title: 'Quality Guarantee',
    description: 'Enjoy peace of mind with Mobile Car Servicing Gold Coast - warranty on all work, fully insured service, and certified mechanics.',
    audience: 'Peace of mind for all customers'
  },
  {
    icon: Users,
    title: 'Flexible Scheduling',
    description: 'Enjoy flexible booking with Mobile Car Servicing Gold Coast, including evenings, weekends, or servicing during work hours at your office.',
    audience: 'Convenient for working professionals'
  },
  {
    icon: CheckCircle,
    title: 'Professional Equipment',
    description: 'We provide Mobile Car Servicing Gold Coast using a fully equipped mobile workshop with professional tools and diagnostic technology.',
    audience: 'Quality you can rely on'
  }
];

export const BenefitsSection = () => {
  const navigate = useNavigate();
  return (
    <section 
      className="py-12 lg:py-24 relative overflow-hidden bg-gradient-to-br from-primary/5 via-background to-muted/10 mobile-section-spacing"
    >
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 hero-pattern opacity-20"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="section-header">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-primary to-primary-hover rounded-2xl mb-8 shadow-[var(--shadow-glow)]">
            <Car className="w-10 h-10 text-white" />
          </div>
          <h2 className="section-title">
            Why Mobile Car Servicing Gold Coast Is the Smart Choice?
          </h2>
          <p className="section-subtitle">
            Designed for busy professionals, families, and businesses seeking reliable, transparent, and professional Mobile Car Servicing Gold Coast delivered to their location.
          </p>
          <div className="section-divider" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-10 mobile-grid-fix">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-item group hover-lift text-center mobile-text-center">
              <div className="section-icon mx-auto mb-4 sm:mb-6 group-hover:scale-110 transition-all duration-300">
                <benefit.icon className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
              </div>
              
              <div className="space-y-4">
                <h3 className="text-xl sm:text-2xl font-bold text-foreground group-hover:text-primary transition-colors duration-300 mobile-text-center">
                  {benefit.title}
                </h3>
                
                <p className="text-muted-foreground leading-relaxed font-medium text-center px-2 mobile-text-center mobile-px-4">
                  {benefit.description}
                </p>
                
                <div className="inline-flex items-center justify-center px-3 sm:px-4 py-2 bg-primary/10 text-primary font-semibold rounded-full text-sm mx-auto">
                  {benefit.audience}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Enhanced CTA Section */}
        <div className="mt-12">
          <div className="bg-gradient-to-r from-primary/10 via-primary/5 to-primary/10 rounded-2xl p-8 border border-primary/10 shadow-[var(--shadow-elegant)]">
            <div className="text-center space-y-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-primary rounded-full mb-6">
                <CheckCircle className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground">
                Ready to Experience the Convenience?
              </h3>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Join over 1000+ satisfied customers who've made the switch to professional mobile mechanic services
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button 
                  onClick={() => navigate('/get-quote')}
                  className="btn-premium text-lg py-4 px-10"
                >
                  Get Your Free Quote Now
                </button>
                <button 
                  onClick={() => navigate('/book-now')}
                  className="btn-outline-premium text-lg py-4 px-10"
                >
                  Book Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};